export default {"src":"/_next/static/media/garden.e67f303b.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};